function idParser(id) {
  return id.substring(7);
}

// console.log(idParser("number-Telegram"));

export default idParser;
